import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { MediaPanel } from "./MediaPanel";

export function MediaDialog({
  slug,
  open,
  onOpenChange,
}: {
  slug: string;
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Solution media</DialogTitle>
          <DialogDescription>
            Audio overviews, video walkthroughs, mind maps — anything that supplements the
            architecture. Media is solution-level and persists across versions.
          </DialogDescription>
        </DialogHeader>
        <MediaPanel slug={slug} />
      </DialogContent>
    </Dialog>
  );
}
